// This file was auto-generated by Fern from our API Definition.
export const OTelStatusCode = {
    StatusCodeUnset: "STATUS_CODE_UNSET",
    StatusCodeOk: "STATUS_CODE_OK",
    StatusCodeError: "STATUS_CODE_ERROR",
};
